<template>
  <div v-if="product" class="catalog-product-modal">
    <div class="catalog-product-modal__block">
      <CatalogSlider v-if="product" :result="product" />
    </div>
    <DefLinkBrown
      v-if="prevProduct"
      class="catalog-product-modal__prev"
      @click="handlerShowPrevProduct"
    >
      <svg viewBox="0 0 20 20">
        <path
          d="M2.89121 9.59158C2.7342 9.74864 2.646 9.96162 2.646 10.1837C2.646 10.4058 2.7342 10.6188 2.89121 10.7758L7.62904 15.5137C7.70629 15.5936 7.79871 15.6574 7.90089 15.7013C8.00307 15.7452 8.11297 15.7683 8.22417 15.7693C8.33538 15.7703 8.44566 15.7491 8.54859 15.707C8.65152 15.6649 8.74503 15.6027 8.82366 15.524C8.9023 15.4454 8.96449 15.3519 9.0066 15.249C9.04871 15.146 9.0699 15.0357 9.06894 14.9245C9.06797 14.8133 9.04487 14.7034 9.00097 14.6013C8.95708 14.4991 8.89327 14.4067 8.81328 14.3294L5.5051 11.0212H16.5963C16.8184 11.0212 17.0315 10.933 17.1885 10.7759C17.3456 10.6189 17.4338 10.4058 17.4338 10.1837C17.4338 9.96158 17.3456 9.74855 17.1885 9.59149C17.0315 9.43443 16.8184 9.34619 16.5963 9.34619H5.5051L8.81328 6.038C8.96584 5.88004 9.05026 5.66849 9.04835 5.44889C9.04644 5.2293 8.95836 5.01924 8.80308 4.86396C8.6478 4.70867 8.43774 4.62059 8.21814 4.61868C7.99855 4.61678 7.78699 4.70119 7.62904 4.85375L2.89121 9.59158Z"
        />
      </svg>

      {{ messages.previousProduct }}
    </DefLinkBrown>
    <DefLinkBrown
      v-if="nextProduct || +pagination.pageNumber + 1 <= +pagination.pageCount"
      class="catalog-product-modal__next"
      @click="handlerShowNextProduct"
    >
      {{ messages.nextProduct }}
      <svg viewBox="0 0 20 20">
        <path
          d="M17.1886 10.7964C17.3456 10.6394 17.4338 10.4264 17.4338 10.2043C17.4338 9.98221 17.3456 9.76922 17.1886 9.61216L12.4508 4.87434C12.3735 4.79434 12.2811 4.73054 12.1789 4.68665C12.0768 4.64275 11.9669 4.61965 11.8557 4.61868C11.7444 4.61772 11.6342 4.63891 11.5312 4.68102C11.4283 4.72313 11.3348 4.78532 11.2562 4.86396C11.1775 4.94259 11.1153 5.0361 11.0732 5.13903C11.0311 5.24196 11.0099 5.35224 11.0109 5.46345C11.0119 5.57465 11.035 5.68455 11.0789 5.78673C11.1227 5.88891 11.1866 5.98133 11.2665 6.05858L14.5747 9.36677H3.48351C3.26139 9.36677 3.04836 9.45501 2.8913 9.61207C2.73423 9.76914 2.646 9.98216 2.646 10.2043C2.646 10.4264 2.73423 10.6394 2.8913 10.7965C3.04836 10.9536 3.26139 11.0418 3.48351 11.0418H14.5747L11.2665 14.35C11.114 14.5079 11.0296 14.7195 11.0315 14.9391C11.0334 15.1587 11.1215 15.3688 11.2767 15.524C11.432 15.6793 11.6421 15.7674 11.8617 15.7693C12.0813 15.7712 12.2928 15.6868 12.4508 15.5342L17.1886 10.7964Z"
        />
      </svg>
    </DefLinkBrown>
    <div>
      <CatalogDescription :result="{ product, messages }" />
      <div class="catalog-product-modal__social">
        <span>{{ messages.share }}</span>
        <DefShare :result="product?.shareLinks"></DefShare>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import CatalogSlider from '@components/Catalog/CatalogSlider.vue';
import CatalogDescription from '@components/Catalog/CatalogDescription.vue';
import DefShare from '@components/Def/DefShare/DefShare.vue';
import Analytics from '@/utils/Analytics';
import DefLinkBrown from '@components/Def/DefLink/DefLinkBrown.vue';

export default {
  name: 'CatalogProductModal',
  components: { DefLinkBrown, DefShare, CatalogDescription, CatalogSlider },
  computed: {
    ...mapState({
      product: ({ product }) => product.data.product,
      messages: ({ product }) => product.data.messages,
      catalogItems: ({ catalog }) => catalog.data.catalogSectionList.items,
      pagination: ({ catalog }) => catalog.data.catalogSectionList.pagination,
    }),
    productIndex() {
      return this.catalogItems.findIndex(
        (el) => el?.offer?.id === this.product?.offer?.id || el?.id === this.product?.id
      );
    },
    nextProduct() {
      return this.catalogItems[this.productIndex + 1];
    },
    prevProduct() {
      return this.catalogItems[this.productIndex - 1];
    },
  },
  methods: {
    ...mapMutations({
      setState: 'product/setState',
      loaderStart: 'global/loaderStart',
      loaderStop: 'global/loaderStop',
      selectPair: 'product/selectPair',
    }),
    ...mapActions({
      getMoreItems: 'catalog/getMoreItems',
    }),
    async handlerShowPrevProduct() {
      try {
        this.loaderStart();

        const prevProduct = this.catalogItems[this.productIndex - 1];

        if (prevProduct) {
          const { status, data } = await axios.get(this.prevProduct.detailPage, {
            params: { api: 'Y' },
          });

          this.setState(data);
          Analytics.viewDetailProduct(data.product);
        }

        this.loaderStop();
      } catch (err) {
        console.error(err);
      }
    },
    async handlerShowNextProduct() {
      try {
        this.loaderStart();
        const { pagination } = this;

        this.index += 1;
        const nextProduct = this.catalogItems[this.productIndex + 1];

        if (!nextProduct && +pagination.pageNumber + 1 <= +pagination.pageCount) {
          const { pageNumber, pagingKey } = this.pagination;

          const query = {
            ...this.$route.query,
            [pagingKey]: +pageNumber + 1,
          };

          await this.$router.replace({ path: this.$route.path, query });

          await this.getMoreItems(this.$route.fullPath);
        }

        if (this.nextProduct) {
          const { status, data } = await axios.get(this.nextProduct.detailPage, {
            params: { api: 'Y' },
          });

          this.setState(data);
          Analytics.viewDetailProduct(data.product);
        }
        this.loaderStop();
      } catch (err) {
        console.error(err);
      }
    },
  },
  beforeUnmount() {
    this.selectPair(false);
  },
};
</script>

<style lang="scss" scoped>
.catalog-product-modal {
  display: grid;
  grid-template-columns: minmax(0, 0.49fr) minmax(0, 0.6fr);
  grid-column-gap: 40px;
  padding: 32px 32px calc(32px + 44px) 32px;
  position: relative;
  &__social {
    display: flex;
    align-items: center;
    //color: var(--color-dark-grey);
    margin-top: 24px;
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    text-transform: uppercase;
  }
  &__block {
    display: flex;
    flex-direction: column;
  }
  :deep(.def-link-brown.catalog-product-modal__prev),
  :deep(.def-link-brown.catalog-product-modal__next) {
    display: flex;
    align-items: center;
    gap: 4px;
    position: absolute;
    bottom: 32px;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    text-transform: uppercase;
    svg {
      width: 20px;
      height: 20px;
      fill: currentColor;
      transition: 2s linear fill;
      transform: translateY(1px);
    }
  }
  &__prev {
    left: 32px;
  }
  &__next {
    right: 32px;
  }
  :deep(.def-share__icon) {
    width: 24px;
    height: 24px;
  }
  :deep(.def-share) {
    margin-left: 16px;
    grid-column-gap: 16px;
  }
}
</style>
